export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M18.99 8c0-1.66-1.33-3-2.99-3s-3 1.34-3 3 1.34 3 3 3 2.99-1.34 2.99-3m-8 0c0-1.66-1.33-3-2.99-3S5 6.34 5 8s1.34 3 3 3 2.99-1.34 2.99-3M1 16.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5s-7 1.17-7 3.5m14.03-3.45c1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5-.29 0-.62.02-.97.05\"/>"
};